<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Ticket"
  >
    <g id="Orion_entrance 1" clip-path="url(#clip0_1530_3962)">
      <path
        id="layer2"
        d="M27.5 9.35C26.8371 9.88194 26.0012 10.1505 25.1526 10.1041C24.3039 10.0577 23.5022 9.69975 22.9012 9.09876C22.3002 8.49778 21.9423 7.6961 21.8959 6.84744C21.8495 5.99879 22.1181 5.16288 22.65 4.5L19.15 1L1 19.15L4.5 22.65C5.16288 22.1181 5.99879 21.8495 6.84744 21.8959C7.6961 21.9423 8.49778 22.3002 9.09876 22.9012C9.69975 23.5022 10.0577 24.3039 10.1041 25.1526C10.1505 26.0012 9.88194 26.8371 9.35 27.5L12.85 31L31 12.85L27.5 9.35Z"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        id="layer1"
        d="M17.05 7.30005L17.75 8.00005M19.85 10.05L20.55 10.75M22.65 12.85L23.35 13.55M25.4 15.65L26.1 16.35M5.90002 15.65L6.60002 16.35M8.65002 18.45L9.35002 19.15M11.45 21.25L12.15 21.95M14.25 24L14.95 24.7001"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>

    <defs>
      <clipPath id="clip0_1530_3962">
        <rect width="32" height="32" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
</template>
